import { apiService } from "../api.service";

// Domain
import { Service } from "../../models/app/domain";

const mapDashboardItem = (item = {}) => ({
  items: item?.items?.map(service => new Service(service)),
  total: item?.total
});

export const fetchDashboardRequest = async () => {
  const response = await apiService.get("/services/latest?amount=4");
  if (response.hasError) {
    return response;
  }
  return {
    services: mapDashboardItem(response.data.services),
    requests: mapDashboardItem(response.data.requests),
    notifications: mapDashboardItem(response.data?.notifications)
  };
};
